import React from 'react';
import { useShop } from './shopinfo';
import { ShopContext } from './shopinfo';

import { useContext } from 'react';
import { AuthContext } from './authcontext';
import { useAuth } from './authcontext';

import '../index.css'


const PDFHeader = () => {
 
    const { shopData } = useShop();
    const { user } = useAuth();
    const { additionalInfo } = useContext(ShopContext);
    const adresse = additionalInfo?.records?.[0];   

    //console.log("Current shop data:", shopData); // Debugging


    return (  
            <div className="contentContainer">
                <div className="pdfHeaderContainer">
                    

                    <table>
                        <tr>
                            <td className="pdfHeaderLeft">
                                Bestellt von
                            </td>
                            <td className="pdfHeaderRight"> 
                                {user.aml}
                                <br />
                                <b>{adresse?.vorname} {adresse?.nachname}</b> <br />
                                {adresse?.plz} {adresse?.ort}
                            </td>
                        </tr>
                    </table>

                </div>
         </div> 

    )
}

export default PDFHeader;    


